module.exports = __webpack_public_path__ + "static/img/l19.b29dd43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/l19.png
// module id = VHcK
// module chunks = 0